import React, { useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewModal = ({ id, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);

  var result = data.find((item) => item.id === id);

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          closeModal();
        }}
      >
        <ModalBody className="custom-modal">
          <div>
            <CommonCloseBtn onClose={closeModal}/>
            <h2 className="text-center font-bold text-lg">Vendor details</h2>

            {/* Tab Content */}
            <div
              className="p-6 max-h-96 overflow-y-scroll"
              style={{ maxHeight: "400px", scrollbarWidth: "thin" }}
            >
              <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Company Name
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 ">
                    {result?.company_name}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Authorized Person Name
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.full_name}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    City
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.city_name}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    State
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.state_name}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Address
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.address}
                  </dd>
                </div>
                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    No. of Employees
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.no_of_employees}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    No. of Fleet
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.no_of_fleet}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Company Age
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.company_age}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Contact Number
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.contact_no}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Vendor Reason
                  </dt>
                  <dd
                    className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                    style={{
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {result?.vendor_reason}
                  </dd>
                </div>

                <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                  <dt className="font-medium text-gray-900 dark:text-gray-200">
                    Other
                  </dt>
                  <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                    {result?.other_count &&
                      Object.entries(result.other_count).map(([key, value]) => (
                        <div key={key}>
                          {key}: {value}
                        </div>
                      ))}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
